export class ConfigUrl{
    static readonly host:string = '/api/v1';
}